import { InjectionToken } from '@angular/core';
import { Environment } from '../../types/environment';

export const APP_ENVIRONMENT = new InjectionToken<Environment>('environment');
